import {required, email} from "vuelidate/lib/validators";  
const contactforms = {
    data() { 
      return {   
        contactformsData: { 
            Usertype: null,
            Messagetype: null,
            Gender: null,
            Namesurname: null,
            Phone: null,
            Email: null,
            Subject: null,
            Message: null,
            Isreaded: null,
            Clientip: null,
            Websiteid: null,
            Createdby: null,
            Created: null,
            Deleted: false
          }, 
  
          FormDataType:{
            Messagetype:{FieldName:"Messagetype",Field:"input",FieldTitle:this.$t('contactforms.Add.Messagetype'),ComboDataArray:[{Id:'0',Value:'Şikayet'},{Id:'1',Value:'Öneri'}]}, 
            Namesurname:{FieldName:"Namesurname",Field:"input",FieldTitle:this.$t('contactforms.Add.Namesurname')},  
            Gender:{FieldName:"Gender",Field:"input",FieldTitle:this.$t('contactforms.Add.Gender'),ComboDataArray:[{Id:'0',Value:'Erkek'},{Id:'1',Value:'Kız'}]}, 
            Phone:{FieldName:"Phone",Field:"input",FieldTitle:this.$t('contactforms.Add.Phone')},  
            Email:{FieldName:"Email",Field:"input",FieldTitle:this.$t('contactforms.Add.Email')},  
            Subject:{FieldName:"Subject",Field:"input",FieldTitle:this.$t('contactforms.Add.Subject')},  
            Message:{FieldName:"Message",Field:"input",FieldTitle:this.$t('contactforms.Add.Message')},  
            Websiteid:{FieldName:"Websiteid",Field:"input"},
            Clientip:{FieldName:"Clientip",Field:"input"}
            
            

          } ,
         
      }
    },  
    validations:{ 
      FormData: {  
        Messagetype: {required},   
        Namesurname: {required},  
        Phone:{},   
        Email: {required,email},  
        Subject: {required},   
        Message: {required},  
        Websiteid:{},  
        Gender: {},
        Clientip: {}

  
      }
 
  },
  created(){

         

  }
}
export default contactforms